import { defineMessages } from 'react-intl'

export default defineMessages({
  TotalAmount: {
    id: 'components.OrderInfo.TotalAmount',
    defaultMessage: 'Total Amount',
    description: '请修改',
  },
  MerchantOrderNo: {
    id: 'components.OrderInfo.MerchantOrderNo',
    defaultMessage: 'Merchant Order No.',
    description: '请修改',
  },
  OrderNo: {
    id: 'components.OrderInfo.OrderNo',
    defaultMessage: 'Order No.',
    description: '请修改',
  },
  TransactionDetails: {
    id: 'components.OrderInfo.TransactionDetails',
    defaultMessage: 'Transaction Details',
    description: '请修改',
  },
  TransactionAmount: {
    id: 'components.OrderInfo.TransactionAmount',
    defaultMessage: 'Amount',
    description: '请修改',
  },
})
